import { Origin, Horoscope } from 'circular-natal-horoscope-js';

/** True only for a live Horoscope instance. JSON.stringify drops getters like SunSign. */
export const isLiveHoroscope = (astro) => Boolean(astro?.SunSign?.label);

export const getAstrology = (avatar, houseSystem = 'placidus') => {
  // console.log('getAstrology = ', avatar.aggr);
  
  if (!avatar.dob || !avatar.aggr?.city) {
    return null;
  }


  if (!avatar || !avatar.aggr?.city?.location || !(avatar.dob || avatar.design?.meta?.personality)) {
    // throw new Error('Missing required birth data');
    console.log('Missing required birth data');
    return null;
  } else {

    try {
      const { lat, lon } = avatar.aggr.city.location;
      // Prefer dob, fallback to design.meta.personality
      if (avatar.dob && avatar.dob.includes(' ')) {
        avatar.dob = avatar.dob.replace(' ', 'T')
      }
      const birthDateTime = avatar.dob;
      
      // Plain text parsing: "1983-05-26T16:09:00"
      const [datePart, timePart] = birthDateTime.split('T');
      const [year, month, date] = datePart.split('-').map(Number);
      const [hour, minute] = timePart.split(':').map(Number);
      // month: 0-11 for Origin, so subtract 1
      const origin = new Origin({
        year,
        month: month - 1,
        date,
        hour,
        minute,
        latitude: lat,
        longitude: lon,
        // Remove timezone: 0 to match demo behavior
      });
      
      const horoscopeInstance = new Horoscope({
        origin: origin,
        houseSystem: houseSystem,
        zodiac: "tropical",
        aspectPoints: ['bodies', 'points', 'angles'],
        aspectWithPoints: ['bodies', 'points', 'angles'],
        aspectTypes: ["major"],
        customOrbs: {},
        language: 'en'
      });
      // console.log('horoscopeInstance = ', horoscopeInstance);
      return {
        horoscope: horoscopeInstance,
        origin: origin
      };
    } catch (err) {
      throw new Error(`Astrology calculation failed: ${err.message}`);
    }

  }

};

// Function to format degrees to minutes (rounding to nearest minute)
export const formatDegrees = (degreesString) => {
  // console.log('formatDegrees input:', degreesString);
  
  if (!degreesString) {
    // console.log('formatDegrees: empty input');
    return '';
  }
  
  // Parse the degrees string (e.g., "4° 33' 54''")
  const match = degreesString.match(/(\d+)°\s*(\d+)'\s*(\d+)''/);
  if (!match) {
    console.log('formatDegrees: no match found for pattern, returning original:', degreesString);
    return degreesString;
  }
  
  const degrees = parseInt(match[1]);
  const minutes = parseInt(match[2]);
  const seconds = parseInt(match[3]);
  
  // console.log('formatDegrees parsed:', { degrees, minutes, seconds });
  
  // Round to nearest minute
  let roundedMinutes = minutes;
  if (seconds >= 30) {
    roundedMinutes += 1;
  }
  
  // Handle overflow
  if (roundedMinutes >= 60) {
    roundedMinutes = 0;
    // Note: We don't increment degrees here as it would change the sign
  }
  
  const result = `${degrees}° ${roundedMinutes.toString().padStart(2, '0')}'`;
  // console.log('formatDegrees result:', result);
  return result;
};

// Function to calculate which house a planet belongs to
export const getPlanetHouse = (planet, houses) => {
  // console.log('getPlanetHouse called with:', { planet, houses });
  
  if (!planet?.ChartPosition?.Ecliptic?.DecimalDegrees || !houses || houses.length === 0) {
    console.log('Missing data:', { 
      planetLongitude: planet?.ChartPosition?.Ecliptic?.DecimalDegrees,
      housesLength: houses?.length 
    });
    return 'N/A';
  }
  
  const planetLongitude = planet.ChartPosition.Ecliptic.DecimalDegrees;
  // console.log('Planet longitude:', planetLongitude);
  
  // Find which house the planet belongs to
  for (let i = 0; i < houses.length; i++) {
    const currentHouse = houses[i];
    const nextHouse = houses[(i + 1) % houses.length];
    
    const currentCusp = currentHouse?.ChartPosition?.StartPosition?.Ecliptic?.DecimalDegrees || 0;
    const nextCusp = nextHouse?.ChartPosition?.StartPosition?.Ecliptic?.DecimalDegrees || 0;
    
    console.log(`House ${i + 1}: currentCusp=${currentCusp}, nextCusp=${nextCusp}`);
    
    // Handle the case where we cross 0 degrees
    if (nextCusp < currentCusp) {
      // We're crossing the 0 degree point
      if (planetLongitude >= currentCusp || planetLongitude < nextCusp) {
        console.log(`Planet in house ${i + 1} (crossing 0)`);
        return i + 1;
      }
    } else {
      // Normal case
      if (planetLongitude >= currentCusp && planetLongitude < nextCusp) {
        console.log(`Planet in house ${i + 1} (normal)`);
        return i + 1;
      }
    }
  }
  
  console.log('Planet not found in any house');
  return 'N/A';
};
